import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AppWrapper, ContentWrapper } from './styles/GlobalStyles';
import theme from './styles/theme';
import GlobalStyle from './styles/GlobalStyles';
import BackendHealthGate from './components/BackendHealthGate';

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import Login from './pages/Login';
import BillersPage from './pages/Billers';
import EditBillerPage from './pages/EditBiller';
import CashFlows from './pages/CashFlows';
import EditCashFlow from './pages/EditCashFlow';
import Settings from './pages/Settings';
import Signup from './pages/Signup';
import Expenses from './pages/Expenses';
import EditExpensePage from './pages/EditExpense';
import AboutTheDev from './pages/About Us';
import LandPage from './pages/Landpage'; // LandPage component
import AuthProvider from './components/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Planners from './pages/Planner';
import EditPlannerPage from './pages/EditPlanner';
import Footer from './components/Footer';
import Bills from './pages/Bills';
import Subscriptions from './pages/Subscriptions';
import Investments from './pages/Investments';
import Receivables from './pages/Receivables';
import EditBillPage from './pages/EditBill';
import EditPaymentPage from './pages/EditPayment';
import PaymentsPage from './pages/Payments';

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
    console.log("Sidebar Toggle:", isOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <BackendHealthGate>
        <Router>
          <GlobalStyle />
          <Header isSidebarOpen={isSidebarOpen} onSidebarToggle={handleSidebarToggle} />
          <AuthProvider>
            <Routes>
              {/* LandPage Route - No Sidebar or Header */}
              <Route path="/" element={<LandPage />} />

              {/* Other Routes - with Sidebar and Header */}
              <Route
                path="/*"
                element={
                  <AppWrapper className='app-wrapper'>
                    <Sidebar isSidebarOpen={isSidebarOpen} onSidebarToggle={handleSidebarToggle} />
                    <ContentWrapper isSidebarOpen={isSidebarOpen}>
                      <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route
                          path="/settings"
                          element={
                            <ProtectedRoute>
                              <Settings isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="/edit-biller/:billerId" element={<EditBillerPage />} />
                        <Route
                          path="/billers"
                          element={
                            <ProtectedRoute>
                              <BillersPage isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />

                        {/* BILLS */}
                        <Route path="/edit-bill/:billId" element={<EditBillPage />} />
                        <Route
                          path="/bills"
                          element={
                            <ProtectedRoute>
                              <Bills isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/subscriptions"
                          element={
                            <ProtectedRoute>
                              <Subscriptions isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/investments"
                          element={
                            <ProtectedRoute>
                              <Investments isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/receivables"
                          element={
                            <ProtectedRoute>
                              <Receivables isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />

                        {/* PAYMENTS */}
                        <Route path="/edit-payment/:paymentId" element={<EditPaymentPage />} />
                        <Route
                          path="/payments"
                          element={
                            <ProtectedRoute>
                              <PaymentsPage isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />

                        <Route path="/edit-expense/:expenseId" element={<EditExpensePage />} />
                        <Route
                          path="/expenses"
                          element={
                            <ProtectedRoute>
                              <Expenses isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="/edit-planner/:plannerId" element={<EditPlannerPage />} />
                        <Route
                          path="/planners"
                          element={
                            <ProtectedRoute>
                              <Planners isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="/edit-cash_flow/:cash_flowId" element={<EditCashFlow />} />
                        <Route
                          path="/cash_flows"
                          element={
                            <ProtectedRoute>
                              <CashFlows isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route
                          path="/reports"
                          element={
                            <ProtectedRoute>
                              <Reports isSidebarOpen={isSidebarOpen} />
                            </ProtectedRoute>
                          }
                        />
                        <Route path="/about_the_dev" element={<AboutTheDev isSidebarOpen={{ isSidebarOpen }} />} />
                      </Routes>

                    </ContentWrapper>
                  </AppWrapper>
                }
              />
            </Routes>
            <Footer />
          </AuthProvider>
        </Router>
      </BackendHealthGate>
    </ThemeProvider>
  );
};

export default App;
